"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _htmlReactParser = require("html-react-parser");

var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);

var _dompurify = require("dompurify");

var _dompurify2 = _interopRequireDefault(_dompurify);

var _reactGridGallery = require("react-grid-gallery");

var _reactGridGallery2 = _interopRequireDefault(_reactGridGallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This function takes a list of React Nodes and collapses
 * p elements that only contain an img into a Carousel
 * component with img src's as Carousel's images
 */
function replaceConcurrentPImgWithCarousel(reactNodes) {
  var pickThumbnailFromSrcset = function pickThumbnailFromSrcset(srcSet) {
    if (typeof srcSet !== "string" || !srcSet.length) return;

    var srcs = srcSet.split(/,\s?/);
    var pairs = srcs.map(function (s) {
      return s.split(" ");
    });

    var priority = pairs.map(function (item) {
      return item.length === 2 ? [].concat((0, _toConsumableArray3.default)(item), [Math.abs(parseInt(item[1], 10) - 800)]) : item;
    });
    var ordered = priority.sort(function (a, b) {
      return a.length === 3 && b.length === 3 ? a[2] - b[2] : 0;
    });

    return ordered[0] ? ordered[0][0] : ordered[0];
  };

  var makeCarousel = function makeCarousel(bufferNodes) {
    var imgs = bufferNodes.map(function (n) {
      return n.props.children;
    });
    var nodeWithKey = bufferNodes.find(function (n) {
      return n.key;
    });

    return _react2.default.createElement(_reactGridGallery2.default, {
      lightboxWidth: 2560,
      backdropClosesModal: true,
      enableImageSelection: false,
      images: imgs.map(function (node) {
        return {
          src: node.props.src,
          thumbnail: pickThumbnailFromSrcset(node.props.srcSet) || node.props.src,
          thumbnailWidth: Number(node.props.width),
          thumbnailHeight: Number(node.props.height)
        };
      })
    });
  };

  var reduceWithBuffer = function reduceWithBuffer(_ref, node) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        result = _ref2[0],
        buffer = _ref2[1];

    if (buffer.length === 1) {
      if (node) {
        return [[].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(buffer), [node]), []];
      }

      return [[].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(buffer)), []];
    }

    if (buffer.length > 1) {
      if (node) {
        return [[].concat((0, _toConsumableArray3.default)(result), [makeCarousel(buffer), node]), []];
      }

      return [[].concat((0, _toConsumableArray3.default)(result), [makeCarousel(buffer)]), []];
    }
  };

  var _reactNodes$reduce = reactNodes.reduce(function (_ref3, node) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        result = _ref4[0],
        buffer = _ref4[1];

    var pWithImgOnly = node.type === "p" && node.props.children && node.props.children.type === "img" && node.props.children.props && node.props.children.props.src;

    if (pWithImgOnly) {
      return [result, [].concat((0, _toConsumableArray3.default)(buffer), [node])];
    }

    if (buffer.length >= 1) {
      return reduceWithBuffer([result, buffer], node);
    }

    return [[].concat((0, _toConsumableArray3.default)(result), [node]), []];
  }, [[], []]),
      _reactNodes$reduce2 = (0, _slicedToArray3.default)(_reactNodes$reduce, 2),
      finalResult = _reactNodes$reduce2[0],
      finalBuffer = _reactNodes$reduce2[1];

  if (finalBuffer.length >= 1) {
    var _reduceWithBuffer = reduceWithBuffer([finalResult, finalBuffer], null),
        _reduceWithBuffer2 = (0, _slicedToArray3.default)(_reduceWithBuffer, 1),
        lastResult = _reduceWithBuffer2[0];

    return lastResult;
  }

  return finalResult;
}

function Content(props) {
  var children = props.children;


  if (!children || typeof children !== "string") {
    return null;
  }

  var clean = _dompurify2.default.sanitize(children, {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["target"],
    FORBID_ATTR: ["style"]
  });

  var parsed = (0, _htmlReactParser2.default)(clean, {
    trim: true
  });

  // const withImageGallery = replaceConcurrentPImgWithCarousel(parsed);

  return _react2.default.createElement(
    "div",
    null,
    parsed
  );
}

exports.default = Content;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Credits/Articles.Content.jsx
// module id = 3040
// module chunks = 0